import React, { useEffect, useState } from 'react';
import Header from '../../components/Header/Header';
import { getRMUser } from '../../redux/user/userSlice';
import { useDispatch } from 'react-redux';
import RMTable from '../../components/RMTable/RMDetailsTable';

interface User {
    id: number;
    firstName: string;
    email: string;
    mobile: string;
    createdAt: string;
    aumUserId:string;
}

const RMDetails: React.FC = () => {
    const [editUser, setEditUser] = useState<User | null>(null);
    const [loader, setLoader] = useState<boolean>(false);
    const [users, setUsers] = useState<User[]>([]);
    const [totalPages, setTotalPages] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [search, setSearch] = useState<string>('');
    
    const dispatch = useDispatch<any>();

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = event.target;
        if (editUser) {
            setEditUser((prevUser) => ({
                ...prevUser!,
                [name]: value,
            }));
        }
    };

    const handleCancel = () => {
        setEditUser(null);
    };

    const fetchUsers = async ( pageIndex: number, pageSize: number, search: string) => {
        setLoader(true);
        try {
            const response = await dispatch(getRMUser({userType:2,pageIndex, pageSize, search }));
            if(response?.error?.message) {
                setUsers([]);
                setTotalPages(0);
                setCurrentPage(1);
                return;
            }
            const data = response.payload.data; 
            const totalPages = response.payload.totalPages; 

            setUsers(data);
            setTotalPages(totalPages);
            setCurrentPage(Math.min(pageIndex, totalPages)); 

        } catch (error) {
            console.error('Error fetching user data:', error);
        } finally {
            setLoader(false);
        }
    };

    useEffect(() => {
        fetchUsers(currentPage, pageSize, search);
    }, [dispatch, currentPage, pageSize, search]);

    const handlePageChange = (event: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => {
        setCurrentPage(newPage + 1); // Set current page (1-based index)
        fetchUsers(newPage + 1, pageSize, search); // Fetch data for the new page
    };    

    const handlePageSizeChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setPageSize(parseInt(event.target.value, 10));
        setCurrentPage(1); // Reset to first page whenever page size changes
    };

    const refreshUsers = () => {
        fetchUsers(currentPage, pageSize, search);
    };

    return (
        <div>
            <RMTable
                users={users}
                onChange={handleChange}
                onCancel={handleCancel}
                totalPages={totalPages}
                currentPage={currentPage}
                pageSize={pageSize}
                onPageChange={handlePageChange}
                onPageSizeChange={handlePageSizeChange}
                searchQuery={search}
                setSearchQuery={setSearch}
                onRefresh={refreshUsers}
            />
        </div>
    );
};

export default RMDetails;
